(() => {
  const init = () => {
    document.querySelectorAll('[data-creator-hub]').forEach((hub) => {
      hub.querySelectorAll('a[href^="#"]').forEach((link) => {
        link.addEventListener('click', (event) => {
          const target = hub.querySelector(link.getAttribute('href'));
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });

      const storyToggles = hub.querySelectorAll('.creator-stories__toggle[aria-controls]');
      const setStoryOpen = (toggle) => {
        const panel = hub.querySelector(`#${CSS.escape(toggle.getAttribute('aria-controls'))}`);
        if (!panel) return;
        const willOpen = toggle.getAttribute('aria-expanded') !== 'true';

        storyToggles.forEach((otherToggle) => {
          const otherPanel = hub.querySelector(`#${CSS.escape(otherToggle.getAttribute('aria-controls'))}`);
          otherToggle.setAttribute('aria-expanded', 'false');
          otherToggle.closest('.creator-stories__card')?.classList.remove('is-story-open');
          if (otherPanel) otherPanel.hidden = true;
        });

        if (willOpen) {
          toggle.setAttribute('aria-expanded', 'true');
          toggle.closest('.creator-stories__card')?.classList.add('is-story-open');
          panel.hidden = false;
        }
      };

      storyToggles.forEach((toggle) => {
        toggle.addEventListener('click', () => {
          setStoryOpen(toggle);
        });
        toggle.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            setStoryOpen(toggle);
          }
        });
      });

      const items = hub.querySelectorAll('[data-reveal]');
      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        items.forEach((item) => item.classList.add('is-visible'));
        return;
      }
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.12 });
      items.forEach((item) => observer.observe(item));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
